// Beta Welcome banner — shown once on Home, dismissible per-user.
// localStorage stores ONLY a boolean flag (`'1'`) for "user dismissed the banner".
// No PII, no tokens, no user content — safe by design.
import { useState } from 'react';

const KEY = 'sg.beta.welcome.dismissed.v1';

export const BetaWelcomeBanner = () => {
  const [dismissed, setDismissed] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.localStorage?.getItem(KEY) === '1';
  });
  if (dismissed) return null;

  const close = () => {
    if (typeof window !== 'undefined' && window.localStorage) {
      try { window.localStorage.setItem(KEY, '1'); } catch { /* ignore */ }
    }
    setDismissed(true);
  };

  return (
    <div data-testid="beta-welcome-banner"
      className="mx-6 md:mx-12 lg:mx-16 mt-6 max-w-5xl md:mx-auto bg-[#0D0D0D] text-[#F7F5F1] border border-[#C7A96B]/40 rounded-3xl px-6 py-5 flex items-start gap-4">
      <span className="font-sans text-[10px] uppercase tracking-[0.3em] text-[#C7A96B] flex items-center gap-2 whitespace-nowrap pt-0.5">
        <span className="w-1.5 h-1.5 bg-[#C7A96B] rounded-full" />
        Private Beta
      </span>
      <p className="flex-1 font-sans text-[13px] md:text-sm leading-relaxed text-[#F7F5F1]/85">
        StyleGenome is in Private Beta. Your feedback helps improve your AI stylist,
        outfit recommendations, and closet intelligence.
      </p>
      <button onClick={close} data-testid="beta-welcome-dismiss" aria-label="Dismiss"
        className="text-2xl leading-none text-[#F7F5F1]/60 hover:text-[#F7F5F1] min-h-[44px] min-w-[44px] flex items-center justify-center">×</button>
    </div>
  );
};

export default BetaWelcomeBanner;
